import { Validator } from 'vee-validate'

const dict = {
  en: {
    messages: {
      is: (field, params) => `The ${field} field must be ${params}`
    }
  }
}

Validator.localize(dict)
